import { createAction, props } from '@ngrx/store';
import { IRejectBusinessFicaDocuments } from '../models/reject-business-fica-documents.model';

export const loadRejectBusinessFicaDocuments = createAction(
  '[RejectBusinessFicaDocument] Load RejectBusinessFicaDocuments',
  props<{
    businessId: string;
    uploadedFileId: string;
    request: IRejectBusinessFicaDocuments;
  }>()
);

export const loadRejectBusinessFicaDocumentsSuccess = createAction(
  '[RejectBusinessFicaDocument] Load RejectBusinessFicaDocuments Success',
  props<{ response: string }>()
);

export const loadRejectBusinessFicaDocumentsFailure = createAction(
  '[RejectBusinessFicaDocument] Load RejectBusinessFicaDocuments Failure',
  props<{ error: Error | any }>()
);
